module.exports = __webpack_public_path__ + "img/result-bg_d49b2c7cd.png";